import { useState } from 'react';
import Filter from '../../components/Filter/Filter';
import DataMap from '../../components/DataMap/DataMap';
import ActionGrid from '../../components/ActionGrid/ActionGrid';
import { Icon } from 'leaflet';
import dayjs from 'dayjs';
import {useDeviceFilter} from '../../hooks/useFilter';
import { fetchNetworkQuality, getModalData } from '../../Helpers/fetchDevices';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const customIcon = new Icon({
    iconUrl : require('../../components/DataMap/assets/marker.png'),
    iconSize: [38,38]
})


const actions = [
    'excellent',
    'good',
    'medium',
    'bad',
    'error',
    'gateway',
    "off"
];



const NetworkQuality = () => {
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [filters, setFilters] = useState({
        Search: "",
        fromDate: dayjs().add(0, "day").startOf("day"),
        toDate: dayjs().add(0, "day").startOf("day"),
        fromTime: dayjs().subtract(2, 'hour').startOf('hour'),
        toTime: dayjs().startOf('hour'),
        deviceStates: {
          excellent: true,
          good: true,
          medium: true,
          bad: true,
          error: true,
        },
        gateway : ""
      });
    
    const {gateways,devices, statusCounts, handleSearchClick } = useDeviceFilter(filters, fetchNetworkQuality, "networkQuality");
  

    const handleMarkersSelected = (results) => {
        if (results) {
          setSelectedDevices(results);
        }
    };
    
    return (
        <>
            <div className="mb-4">
                <ActionGrid actions = {actions} statusCounts = {statusCounts}/>
            </div>
            <div className="mb-4">
                <div className="mb-4">
                    <Filter filters={filters} setFilters={setFilters} onSearch={handleSearchClick} />
                </div>
                
                <FormControl fullWidth>
                    <InputLabel>Επιλογή Gateway</InputLabel>
                    <Select
                        value={filters.gateway}
                        label="Τύπος Αναφοράς"
                        onChange={(e) => setFilters(prev => ({ ...prev, gateway: e.target.value }))}
                    >
                        <MenuItem value="">Επιλέξτε</MenuItem>
                        <MenuItem value="all">Όλα τα Gateways (Πιθανή Καθυστέρηση)</MenuItem>
                        {gateways.map((gateway, idx) => (
                        <MenuItem key={idx} value={gateway}>{gateway}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="mb-4">
                <DataMap markers ={devices} customIcon = {customIcon} deviceType ={"networkQuality"} onMarkersSelected={handleMarkersSelected} modalFetcher={getModalData}/> 
            </div> 
        </>
    
    );
};
    
export default NetworkQuality;